import angular from 'angular';
import '../../shared.module';
import template from './empty-state.component.html';
import './empty-state.component.scss';

class EmptyStateController {
  $onInit() {
    this.icon = this.icon || 'file-text';
  }
}

angular.module('app.shared').component('cpEmptyState', {
  bindings: {
    icon: '@',
    title: '@',
    description: '@'
  },
  transclude: true,
  controller: EmptyStateController,
  controllerAs: 'vm',
  template
});
